module.exports = __webpack_public_path__ + "img/logoEasy.764f5033.png";